















import Component, { mixins } from "vue-class-component";
import { DataLoggerFormModel } from "@/context/data_logger/model/form/DataLoggerFormModel";
import { DataLoggerModel } from "@/context/data_logger/model/form/DataLoggerModel";
import { dataLoggerApi } from "@/context/data_logger/api/DataLoggerApi";
import { dataLoggerRouter } from "@/context/data_logger/router/DataLoggerRouter";
import Form from "@/general/abstract/form/mixin/Form";
import DataLoggerFormTemplate from "@/context/data_logger/component/DataLoggerFormTemplate.vue";
import FormBase from "@/general/abstract/form/FormBase.vue";
import { VModel } from "vue-property-decorator";

@Component({
  components: {
    FormBase,
    DataLoggerFormTemplate
  }
})
export default class DataLoggerForm extends mixins<
  Form<DataLoggerFormModel, DataLoggerFormModel, DataLoggerModel>
>(Form) {
  @VModel({ default: new DataLoggerFormModel() }) model!: DataLoggerFormModel;

  buildCmd(): DataLoggerFormModel | Record<string, unknown> {
    if (this?.model?.id) {
      return this.model;
    }
    let command: Record<string, unknown> = Object.assign<
      Record<string, unknown>,
      DataLoggerFormModel
    >({}, this.model);
    delete command.id;
    return command;
  }

  async submitApi(cmd: DataLoggerFormModel): Promise<DataLoggerModel> {
    const model: DataLoggerModel = cmd.id
      ? await dataLoggerApi.update<DataLoggerFormModel, DataLoggerModel>(cmd)
      : await dataLoggerApi.create<DataLoggerFormModel, DataLoggerModel>(cmd);
    return model;
  }

  showRoute(id: number): Record<string, unknown> {
    return dataLoggerRouter.show(id);
  }
}
